export default function insertScript(url) {
    return new Promise(function (resolve) {
        var matchScriptUrl = function (scriptElem) { return scriptElem.src.replace(/^http(s?):/i, '') === url.replace(/^http(s?):/i, ''); };
        if (Array.prototype.find.call(document.getElementsByTagName('script'), matchScriptUrl)) {
            resolve();
        }
        else {
            var script = document.createElement('script');
            script.src = url;
            script.onload = resolve;
            document.head.appendChild(script);
        }
    });
}
